import { Button } from '@insify/design-system/components';
import { PopupButton } from '@typeform/embed-react';

import { useUiStore } from '../../stores/uiStore';

import type { ButtonProps } from '@insify/design-system/components';
import type React from 'react';

const formIds = {
  personal_cancel_contract_nl: 'gaNr8V5K',
  personal_cancel_contract_fr: '', // This combo doesn't exist yet, keeping it here to stay consistent
  personal_cancel_contract_de: '', // This combo doesn't exist yet, keeping it here to stay consistent
  company_cancel_contract_nl: 'VWtAx1Ar',
  company_cancel_contract_fr: 'duUflwaI',
  company_cancel_contract_de: 'ZlqXiX9E',
  change_form_nl: 'MPtZLgUL',
  change_form_fr: 'Bvm7c4GE',
  change_form_de: 'IWaU8MXL',
};

type countryType = 'nl' | 'fr' | 'de';
type Props = {
  label: string;
  formType: 'cancel_contract' | 'change_form';
  policyType: 'personal' | 'company';
  hiddenFields: {
    email?: string;
    policy_number?: string;
    name?: string;
    change_type?:
      | 'company_address'
      | 'personal_address'
      | 'bank_account'
      | 'contact_details'
      | 'company_registration'
      | 'cancel_contract';
    country?: 'NL' | 'FR' | 'DE';
    phone?: string;
  };
  trackingId: string;
  kind: 'neutral' | 'primary' | 'secondary';
  confirmation?: string;
} & ButtonProps;

export const TypeformButton: React.FC<Props> = ({
  hiddenFields,
  formType,
  label,
  confirmation,
  policyType,
  ...props
}: Props) => {
  const { setNotification } = useUiStore();

  // TODO: default to nl because we don't populate the country field yet on socotra endpoint
  const country = (hiddenFields.country?.toLowerCase() ?? 'nl') as countryType;
  const formName: keyof typeof formIds =
    formType === 'cancel_contract' ? `${policyType}_${formType}_${country}` : `${formType}_${country}`;

  const formId = formIds[formName];
  if (!formId) {
    console.error(`Form ID not found for formName: ${formName}`);
    return null;
  }

  return (
    <>
      <PopupButton
        id={formId}
        hidden={hiddenFields}
        as='div'
        keepSession={false}
        onSubmit={() => confirmation && setNotification(confirmation)}
        autoClose={100}
      >
        <Button {...props} type='button'>
          {label}
        </Button>
      </PopupButton>
    </>
  );
};
